import { useStore } from "@nanostores/preact";
import { useState } from "preact/hooks";
import { $panel, $pendingPlace, $placeSubmit } from "../state/stores";
import { parseTags, validateRole } from "../world/rules";
import { Panel } from "./Panel";

/** The panel's collider choice: "" leaves the component out so the entity collides by its shape (spec 2k §5.1). */
export type ColliderChoice = "" | "box" | "none";

export function colliderComponentsJson(choice: ColliderChoice): string {
  return choice ? JSON.stringify({ collider: { mode: choice } }) : "{}";
}

export function PlacePropsPanel() {
  const pending = useStore($pendingPlace);
  const [role, setRole] = useState("");
  const [tags, setTags] = useState("");
  const [collider, setCollider] = useState<ColliderChoice>("");
  const [error, setError] = useState<string | null>(null);
  if (!pending) return null;

  function close() {
    $pendingPlace.set(null);
    $panel.set(null);
  }

  function submit(e: Event) {
    e.preventDefault();
    const roleErr = validateRole(role.trim());
    const parsed = parseTags(tags);
    if (roleErr || parsed.error) { setError(roleErr ?? parsed.error); return; }
    $placeSubmit.set({ ...pending!, role: role.trim(), tags: parsed.tags, componentsJson: colliderComponentsJson(collider) });
    close();
  }

  return (
    <Panel title={`擺放到「${pending.plotName}」`} onClose={close}>
      <form onSubmit={submit}>
        <label>role（選填，腳本用來找這個物件）</label>
        <input type="text" value={role} placeholder="例如 patient" onInput={(e) => setRole((e.target as HTMLInputElement).value)} />
        <label>標籤（選填，以逗號分隔）</label>
        <input type="text" value={tags} placeholder="例如 npc, red" onInput={(e) => setTags((e.target as HTMLInputElement).value)} />
        <label>碰撞</label>
        <select value={collider} onChange={(e) => setCollider((e.target as HTMLSelectElement).value as ColliderChoice)}>
          <option value="">依形狀（預設）</option>
          <option value="box">包圍盒</option>
          <option value="none">可穿越</option>
        </select>
        <div class="hint">物件預設是固體；招牌、光效這類不該擋人的選可穿越。</div>
        <button type="submit">擺放</button>
        {error && <div class="error">{error}</div>}
      </form>
    </Panel>
  );
}
